import React from "react";
import PropTypes from "prop-types";
import {extractMessage, fetchResponseHandler} from "../../../util/FetchUtil";
import AlertComponent from "../../../util/AlertComponent";
import ProcessingComponent from "../../../util/ProcessingComponent";
import {isBlank} from "../../../util/StringUtil";
import UpdateEmailComponent from "./UpdateEmailComponent";

const MSG_RESENT_SUCCESS = "We re-sent the verification email. Please check your inbox.";

class VerifyEmailComponent extends React.Component {
    constructor(props){
        super(props);
        this.state = {};
        this.clearMessage = this.clearMessage.bind(this);
        this.setShowProcessing = this.setShowProcessing.bind(this);
        this.sendVerificationEmail = this.sendVerificationEmail.bind(this);
        this.setShowUpdate = this.setShowUpdate.bind(this);
        this.showError = this.showError.bind(this);
        this.resendEmail = this.resendEmail.bind(this);
        this.showUpdate = this.showUpdate.bind(this);
        this.hideUpdate = this.hideUpdate.bind(this);
        this.getEmail = this.getEmail.bind(this);
        this.goToTargetLocation = this.goToTargetLocation.bind(this);
    }

    componentDidMount() {
        const {sendOnMount} = this.props;
        if(sendOnMount) {
            this.sendVerificationEmail();
        }
    }

    sendVerificationEmail(newEmail){
        const {sendVerificationEmailFunction, activationEmailOption={}} = this.props;
        this.setShowProcessing(true);
        const serviceParam = isBlank(newEmail) ? activationEmailOption : {...activationEmailOption, email: newEmail};
        sendVerificationEmailFunction(serviceParam)
            .then(fetchResponseHandler)
            .then(data => {
                const {email, status} = data;
                if (status === "ALREADY_ACTIVE"){
                    this.clearMessage();
                    this.setState(state => ({...state, alreadyActive: true}));
                } else {
                    this.setState(state => ({
                        ...state,
                        email,
                        message: MSG_RESENT_SUCCESS,
                        messageType: "success",
                        showUpdate: false
                    }));
                }
            })
            .catch(this.showError)
            .finally(() => {
                this.setShowProcessing(false);
            })
        ;
    }

    clearMessage(){
        this.setState(state => ({...state, message: null, messageType: null}))
    }

    setShowProcessing(showProcessing){
        this.setState(state => ({...state, showProcessing}));
    }

    setShowUpdate(showUpdate){
        this.setState(state => ({...state, showUpdate}));
    }

    showUpdate(e){
        e.preventDefault();
        this.clearMessage();
        this.setShowUpdate(true);
    }

    hideUpdate(e){
        e.preventDefault();
        this.setShowUpdate(false);
    }

    showError(e){
        const message = extractMessage(e);
        this.setState(state => ({
            ...state,
            message,
            messageType: "error"
        }));
    }

    resendEmail(e){
        e.preventDefault();
        const {email} = this.state;
        this.sendVerificationEmail(email);
    }

    getEmail(){
        const {activationEmailOption} = this.props;
        let {email} = this.state;
        if(!email || email.length == 0){
            email = activationEmailOption.email;
        }
        return email;
    }

    goToTargetLocation(){
        const {targetLocation} = this.props;
        const target = targetLocation + (targetLocation.indexOf("?") >= 0 ?  "&" : "?") + "email=" + this.getEmail();
        window.location.href = target;
    }



    render(){
        const {allowEmailUpdate, onCancel, alreadyActiveMessage, activationEmailOption, targetLocation, targetDescription} = this.props;
        const {message, messageType, showProcessing, showUpdate, alreadyActive} = this.state;
        const email = this.getEmail();

        return (
            <div className="max-width-md">
                {
                    alreadyActive &&
                    <AlertComponent
                        type="warning"
                        attention={true}
                        message={
                            alreadyActiveMessage ? alreadyActiveMessage : "The email is already verified. You may need to login again."
                        }
                    />
                }
                <AlertComponent
                    message={message}
                    type={messageType}
                    onClose={this.clearMessage}
                    attention={true}
                />
                {
                    ! showUpdate &&
                    <div>
                        <div>Almost done...</div>
                        <h1>Check your email</h1>
                        <div>
                            We've sent the verification link to <strong>{email}</strong>
                            {
                                allowEmailUpdate &&
                                <span>{' '}(<a href="#" onClick={this.showUpdate}>not my email</a>)</span>
                            }
                        </div>
                        <div className="push--ends">
                            Please allow 5-10 minutes for this message to arrive. If you haven't gotten the email, check
                            your spam folder or contact your system administrator.
                        </div>
                        <div>
                            {
                                onCancel &&
                                <button className="btn btn--large btn--outline push-half--right" onClick={onCancel}>Cancel</button>
                            }
                            <button className={"btn btn--large" + (onCancel ? "" : " btn--outline")} onClick={this.resendEmail}><i className="fa fa-refresh"></i> Re-send Email</button>
                            {
                                targetLocation && targetLocation.trim().length > 0 && targetDescription && targetDescription.trim().length > 0 &&
                                <button
                                    className="push--left btn btn--large btn--outline"
                                    onClick={this.goToTargetLocation}
                                >
                                    I will verify later, take me back to {targetDescription}
                                </button>
                            }
                        </div>
                    </div>
                }
                {
                    showUpdate &&
                    <UpdateEmailComponent
                        email={email}
                        onError={this.showError}
                        onCancel={this.hideUpdate}
                        verificationEmailSender={this.sendVerificationEmail}
                    />
                }
                <ProcessingComponent show={showProcessing} message="Re-sending Verification Email"/>
            </div>
        );
    }
}

VerifyEmailComponent.propTypes = {
    sendVerificationEmailFunction: PropTypes.func.isRequired,
    allowEmailUpdate: PropTypes.bool.isRequired,
    activationEmailOption: PropTypes.object,
    alreadyActiveMessage: PropTypes.object,
    onCancel: PropTypes.func,
    sendOnMount: PropTypes.bool.isRequired,
    targetLocation: PropTypes.string,
    targetDescription: PropTypes.string
};

export default VerifyEmailComponent;